import { cva } from "cva";

export const expandingMenuLinkStyles = cva({
  base: "flex w-full px-16 py-20 w-full text-ginto-23 font-ginto font-normal leading-130",
});
